import React, { useEffect, useState } from 'react';
import { useCommands } from '../api/commands';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

export default function Keys(){
  const cmd = useCommands();
  const nav = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function load(){
    setLoading(true); setError('');
    try{
      const data = await cmd.api?.get?.('/gpm/keys').then(r=>r.data).catch(()=>[]);
      setRows(Array.isArray(data) ? data : []);
    }catch(e){
      setError(e?.response?.data?.error || e?.message || 'Failed to load keys');
    }finally{ setLoading(false); }
  }
  useEffect(()=>{ load(); }, []);

  return (
    <div className="container">
      <PageHeader
        eyebrow="GPM"
        title="Keys"
        actions={
          <>
            <button className="btn secondary" onClick={()=>nav('/dashboard')}>Back</button>
            <button className="btn secondary" onClick={load}>Reload</button>
          </>
        }
      />

      {error && <div className="page-alerts"><div className="alert error">{error}</div></div>}

      <div className="card">
        {loading ? <div className="empty">Loading</div> : rows.length===0 ? (
          <div className="empty">No keys.</div>
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Key</th>
                  <th>Holder</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((k, i)=>(
                  <tr key={k.id || k.code || i}>
                    <td className="cell-strong">{k.code || k.name || '—'}</td>
                    <td>{k.holder || '—'}</td>
                    <td>{k.notes || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
